/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, breakpoints } from '@coursera/cds-core';

const styles = {
  layout: css`
    display: grid;
    grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);
    grid-template-areas:
      'rating product'
      'rating content';
    gap: 0 42px;
    align-items: start;
    margin-top: var(--cds-spacing-200);

    ${breakpoints.down('sm')} {
      grid-template-columns: 1fr;
      grid-template-areas:
        'product'
        'rating'
        'content';
      gap: var(--cds-spacing-200);
    }
  `,
  ratingColumn: css`
    grid-area: rating;
    min-width: 0;
  `,
  productColumn: css`
    grid-area: product;
    min-width: 0;
  `,
  content: css`
    grid-area: content;
    min-width: 0;
  `,
};

type Props = {
  backButton: React.ReactNode;
  productCard: React.ReactNode;
  ratingCard: React.ReactNode;
  children: React.ReactNode;
  seoElements?: React.ReactNode;
};

/**
 * Shared page shell for the course and specialization/professional-certificate reviews pages --
 * back button, product/rating cards, and a content column (top reviews + reviews table).
 */
const ReviewsPageLayout = ({ backButton, productCard, ratingCard, children, seoElements }: Props) => (
  <PageGridContainer>
    <Grid item xs={12}>
      {backButton}
      <div css={styles.layout}>
        <div css={styles.productColumn}>{productCard}</div>
        <aside css={styles.ratingColumn} data-testid="reviews-rating-column">
          {ratingCard}
        </aside>
        <div css={styles.content}>{children}</div>
      </div>
      {seoElements}
    </Grid>
  </PageGridContainer>
);

export default ReviewsPageLayout;
